<script setup lang="ts">

</script>
<template>
  <div class="home">
  </div>
</template>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.input-id {
  display: flex;
  gap: 12px;
}

input {
  width: 300px;
}

button {
  cursor: pointer;
}
</style>
